import type { ReactNode } from 'react';
import { styles } from '@/shared/app-list-layout/styles';
import type { AppListLayoutProps } from '@/shared/app-list-layout/types';

/**
 * The layout header: page title, description and the module's toolbar actions.
 *
 * Extracted verbatim from the layout body so the entry point stays within its
 * line budget while the layout gains the engine delegation.
 *
 * The text block is its own element rather than a bare `<div>` so it can take
 * `w-full` below `sm` — that is what pushes the toolbar onto a second row on a
 * phone instead of letting it wrap up beside the description.
 */
export function Header<T>(props: AppListLayoutProps<T>): ReactNode {
  return (
    <header className={styles.header}>
      <div className={styles.headerText}>
        <h1 className={styles.title}>{props.title}</h1>
        {props.description ? <p className={styles.description}>{props.description}</p> : null}
      </div>
      {props.toolbarActions ? <div className={styles.toolbar}>{props.toolbarActions}</div> : null}
    </header>
  );
}
